var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLocked)?_vm._t("default"):_c('div',{staticClass:"block block-rounded text-center py-6"},[_c('premium-icon',{staticClass:"feature-gate-icon mb-4"}),_c('h3',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t('featureGate.title')))]),_c('p',{staticClass:"text-muted mb-4"},[_vm._v(_vm._s(_vm.$t('featureGate.not_available')))])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }